import { Box, BoxProps, Collapse, SvgIcon, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import { AccordionHeader } from "../../salify-next-layout/default/components/accordion";
import { FlexBox } from "../../salify-next-layout/default/components/flex-box";
import SalifySvgIconString from "../../icon/svg/svg-icon-string";

export interface VariantProps {
  handleItemClick: (index: number) => void;
}

const SalifySideNavbarCategoryList = ({ handleItemClick }: VariantProps) => {
  return (
    <>
      {categories.map((item, parentIndex) => {
        if (item.children?.length)
          return (
            <NavAccordion key={parentIndex} name={item.name} svgIconString={item.icon}>
              {item.children}
            </NavAccordion>
          );
        return <_ListItem key={parentIndex} name={item.name} svgIconString={item.icon} />;
      })}
    </>
  );
};

export default SalifySideNavbarCategoryList;

interface _ListItemProps extends Omit<BoxProps, "children"> {
  name: string | undefined;
  svgIconString?: string | undefined;
  children?: _ListItemProps[];
}

function _ListItem({ name: title, svgIconString, ...restProps }: _ListItemProps) {
  return (
    <FlexBox {...restProps} py={1} gap={1.5} alignItems="center">
      {svgIconString && <SalifySvgIconString svgString={svgIconString} />}
      <Typography>{title}</Typography>
    </FlexBox>
  );
}

function NavAccordion(props: _ListItemProps) {
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <AccordionHeader open={open} className="accordion" onClick={() => setOpen((state) => !state)}>
        <_ListItem name={props.name} svgIconString={props.svgIconString} />
      </AccordionHeader>

      {/* RENDER NESTED ITEMS */}
      {props.children && (
        <Collapse in={open}>
          {props.children.map((child) => {
            if (child.children?.length)
              return (
                <Box ml={5} key={child.name}>
                  <NavAccordion name={child.name} svgIconString={child.svgIconString}>
                    {child.children}
                  </NavAccordion>
                </Box>
              );

            return (
              <_ListItem
                key={child.name}
                ml={5}
                name={child.name}
                svgIconString={child.svgIconString}
              />
            );
          })}
        </Collapse>
      )}
    </Fragment>
  );
}

export const categories = [
  {
    name: "Grocery",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16 21q-2.077 0-3.538-1.461T11 16t1.462-3.538T16 11t3.539 1.462T21 16t-1.461 3.539T16 21m0-1q1.65 0 2.825-1.175T20 16t-1.175-2.825T16 12t-2.825 1.175T12 16t1.175 2.825T16 20M4.615 19q-.69 0-1.153-.462T3 17.384v-6.868q0-.2.076-.458t.151-.458l2.23-4.985h-.803q-.329 0-.51-.181t-.183-.511v-.23q0-.33.182-.511T4.653 3h5.693q.329 0 .51.182t.183.51v.231q0 .329-.182.51t-.51.182h-.805l2.497 5.647q-.206.115-.41.274t-.406.356L8.469 4.616H6.531L4 10.342v7.042q0 .27.173.443t.443.173h4.673q.067.275.173.528q.107.253.234.472zM16 9.616q-.646-.174-1.073-.697T14.5 7.692q0-.703.427-1.227q.427-.523 1.073-.696zq.173-.647.696-1.074t1.227-.427t1.227.427t.696 1.074z"/></svg>`,
    path: "#",
    children: [
      {
        name: "Fruits & Vegetables",
        path: "/grocery-4/categories/fruits-vegetables",
        children: [
          {
            name: "Fruits",
            path: "/grocery-4/categories/fruits",
          },
          {
            name: "Vegetables",
            path: "/grocery-4/categories/vegetables",
          },
        ],
      },
      {
        name: "Meat & Fish",
        path: "#",
        children: [
          {
            name: "Meat",
            path: "/grocery-4/categories/meat",
          },
          {
            name: "Fish",
            path: "/grocery-4/categories/fish",
          },
        ],
      },
      {
        name: "Cooking",
        path: "#",
        children: [
          {
            name: "Rice",
            path: "/grocery-4/categories/rice",
          },
          {
            name: "Oil",
            path: "/grocery-4/categories/oil",
          },
        ],
      },
      {
        name: "Sauces & Pickles",
        path: "#",
        children: [
          {
            name: "Pickles",
            path: "/grocery-4/categories/pickles",
          },
          {
            name: "Tomato Sauce",
            path: "/grocery-4/categories/tomato-sauce",
          },
        ],
      },
      {
        name: "Dairy & Eggs",
        path: "#",
        children: [
          {
            name: "Eggs",
            path: "/grocery-4/categories/eggs",
          },
          {
            name: "Cheese",
            path: "/grocery-4/categories/cheese",
          },
        ],
      },
      {
        name: "Breakfast",
        path: "#",
        children: [
          {
            name: "Breads",
            path: "/grocery-4/categories/breads",
          },
          {
            name: "Coffee",
            path: "/grocery-4/categories/coffee",
          },
        ],
      },
      {
        name: "Candy & Chocolate",
        path: "#",
        children: [
          {
            name: "Chocolates",
            path: "/grocery-4/categories/chocolates",
          },
          {
            name: "Candies",
            path: "/grocery-4/categories/candies",
          },
        ],
      },
      {
        name: "Snacks",
        path: "#",
        children: [
          {
            name: "Cookies",
            path: "/grocery-4/categories/cookies",
          },
          {
            name: "Noodles",
            path: "/grocery-4/categories/noodles",
          },
        ],
      },
      {
        name: "Beverages",
        path: "#",
        children: [
          {
            name: "Soft Drinks",
            path: "/grocery-4/categories/soft-drinks",
          },
          {
            name: "Water",
            path: "/grocery-4/categories/water",
          },
        ],
      },
      {
        name: "Frozen & Canned",
        path: "#",
        children: [
          {
            name: "Chicken Snacks",
            path: "/grocery-4/categories/chicken-snacks",
          },
          {
            name: "Beef Snacks",
            path: "/grocery-4/categories/beef-snacks",
          },
        ],
      },
      {
        name: "Diabetic Food",
        path: "/grocery-4/categories/diabetic-food",
      },
    ],
  },
  {
    name: "Beauty & Makeup",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20.172 35.215a4.273 4.273 0 1 1 4.273 4.272c-2.36 0-4.057-1.922-4.273-4.272L17.42 5.5l-2.752 29.715c-.217 2.35-1.914 4.272-4.274 4.272a4.273 4.273 0 1 1 4.274-4.272"/>
        <path d="M6.595 42.5c1.045-.464 2.176-1.936 2.327-3.276"/>
      </g>
      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M29.922 5.524h8.256c2.05 0 3.701 1.65 3.701 3.7v29.248M29.922 24.694h11.957m-11.957-12.78h11.957m-11.957 6.39h11.957"/>
    </svg>`,
    path: "#",
    children: [
      {
        name: "Hand Wash",
        path: "/grocery-4/categories/hand-wash",
      },
      {
        name: "Face Wash",
        path: "/grocery-4/categories/face-wash",
      },
      {
        name: "Tissue & Wipes",
        path: "/grocery-4/categories/tissue-wipes",
      },
    ],
  },
  {
    name: "Electronics",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 19.4V4.6a.6.6 0 0 1 .6-.6h8.8a.6.6 0 0 1 .6.6v14.8a.6.6 0 0 1-.6.6H7.6a.6.6 0 0 1-.6-.6m7 .6v2.5M10 20v2.5M14 4V1.5M10 4V1.5M7 12H4.5m15 0H17M7 6.5H4.5m15 0H17m-10 11H4.5m15 0H17"/></svg>`,
    path: "#",
    children: [
      {
        name: "Lights",
        path: "/grocery-4/categories/lights",
      },
      {
        name: "Mobiles",
        path: "/grocery-4/categories/mobiles",
      },
    ],
  },
  {
    path: "#",
    name: "Furniture",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M2 16v3M4 9V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2"/><path d="M20 9a2 2 0 0 0-2 2v2H6v-2a2 2 0 1 0-4 0v6h20v-6a2 2 0 0 0-2-2m2 7v3"/></g></svg>`,
    children: [
      {
        name: "Bed",
        path: "/grocery-4/categories/bed",
      },
    ],
  },
  {
    path: "#",
    name: "Fashion",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><path fill="currentColor" d="M200 44h-22.34l-14.83-14.83A4 4 0 0 0 160 28H96a4 4 0 0 0-2.83 1.17L78.34 44H56a12 12 0 0 0-12 12v152a12 12 0 0 0 12 12h144a12 12 0 0 0 12-12V56a12 12 0 0 0-12-12m-72 28.79L103.47 36h49.06Zm32.62-34.51L172 49.66V104a4 4 0 0 1-2.3 3.63a3.93 3.93 0 0 1-4.21-.51l-32.2-27.82ZM84 49.66l11.38-11.38l27.33 41l-32.17 27.8A4 4 0 0 1 84 104ZM52 208V56a4 4 0 0 1 4-4h20v52a11.89 11.89 0 0 0 6.91 10.87A12.1 12.1 0 0 0 88 116a11.88 11.88 0 0 0 7.65-2.8h.06L124 88.74V212H56a4 4 0 0 1-4-4m152 0a4 4 0 0 1-4 4h-68V88.74l28.32 24.46A11.9 11.9 0 0 0 168 116a12.1 12.1 0 0 0 5.12-1.15A11.89 11.89 0 0 0 180 104V52h20a4 4 0 0 1 4 4Z"/></svg>`,
    children: [
      {
        name: "Men's Fashion",
        path: "/grocery-4/categories/men-fashion",
      },
      {
        name: "Women's Fashion",
        path: "/grocery-4/categories/women-fashion",
      },
    ],
  },
  {
    name: "Bakery",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.87 17.412q.828.436 1.365-.206q.536-.642.138-1.414l-1.911-3.584l-1.666 4.123zm-5.308-.912h2.084l2.439-6.027q.229-.565.078-.914t-.57-.52l-2-.8q-.457-.191-.88-.047t-.474.639zm-7.208 0h2.085l-.677-7.746q-.05-.39-.455-.548t-.9.033l-2 .8q-.45.19-.527.597t.112.914zm-3.223.912l2.073-1.081l-1.627-4.123l-1.95 3.661q-.436.79.148 1.366t1.356.177m6.308-.912h3.123l.788-8.911q.05-.456-.228-.773q-.278-.316-.772-.316h-2.7q-.373 0-.709.288q-.335.287-.291.723zm-6.91 2.039q-.87 0-1.45-.596t-.579-1.44q0-.28.068-.548t.193-.524L4.077 11q-.33-.865-.08-1.716t1.045-1.173l2-.8q.427-.182.874-.184q.446-.002.796.265q.08-.783.629-1.337q.548-.555 1.339-.555h2.67q.78 0 1.339.526t.677 1.29q.292-.281.738-.225t.854.22l2 .8q.808.323 1.092 1.164t-.089 1.675l2.316 4.43q.112.218.187.437t.075.456q0 .933-.648 1.599q-.647.667-1.571.667q-.226 0-.43-.054q-.205-.052-.41-.158l-1.626-.827H6.134l-1.515.789q-.248.136-.524.193t-.566.056m8.49-6.519"/></svg>`,
    path: "/grocery-4/categories/bakery",
  },
];
